import React from 'react';
import Typography from '@mui/material/Typography';

const formatAmount = (amount) =>
  amount ? parseFloat(amount.toFixed(2)).toLocaleString() : 0;

// eslint-disable-next-line react/prop-types
function AmountInfo({ alignment, title, value }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: alignment,
      }}
    >
      <Typography
        variant="caption"
        noWrap
        sx={{ fontSize: '14px', color: (theme) => theme.palette.grey.darker }}
      >
        {title}
      </Typography>
      <Typography variant="button" noWrap sx={{ fontSize: '16px' }}>
        {`${formatAmount(value)} EUR`}
      </Typography>
    </div>
  );
}

export default AmountInfo;
